
import Wing from "../../../assets/duotone/Wing.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WingIcon({ className, dataTestid = "WingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Wing data-testid={dataTestid} className={classes} {...rest} />
  );
}
